// Keep the last known count when a request fails; an unavailable endpoint is
// not evidence that the department has no tickets.
export async function loadDepartmentTicketTotals(departments, previousTotals, getTickets) {
  return Promise.all(departments.map(async department => {
    try {
      const response = await getTickets({
        internal: true, itemsPerPage: 1, 'department.id': department.id,
      });
      const total = response?.data?.['hydra:totalItems'];
      const valid = total != null && Number.isFinite(Number(total));
      return [department.id, valid ? Number(total) : (previousTotals[department.id] || 0), !valid];
    } catch {
      return [department.id, previousTotals[department.id] || 0, true];
    }
  }));
}

// Un departamento que acepta tickets tiene su pestaña aunque aún no tenga ninguno (su responsable
// tiene que poder verla para recibirlos); uno que ya no los acepta solo mientras conserve tickets.
export function departmentsToShow(departments, totals) {
  return departments.filter(department => department.acceptsTickets === true || totals[department.id] > 0);
}
